import { ConversationThread } from "../features/conversation/ConversationThread";

export const ACTION_MESSAGE_PARTNER = "message_partner";
export const ACTION_SHARE_TO_NETWORK = "share_to_network";
export const ACTION_CHECK_IN = "check_in";
export const ACTION_COMPLETE_ACTION = "complete_action";
export const ACTION_START_SPRINT = "start_sprint";
export const ACTION_OPEN_SPRINT = "open_sprint";
export const ACTION_ENCOURAGE = "encourage";

function warnInDev(action, warnings) {
  if (!warnings.length) return;
  if (process.env.NODE_ENV !== "production") {
    console.warn(`[action-intents] ${action}: ${warnings.join(" | ")}`);
  }
}

export function getPartnerMessageLabel(name) {
  return new ConversationThread({ partnerName: name }).messageLabel;
}

export function resolveWebAction(key, context = {}) {
  const warnings = [];
  const source = context.source || "unknown";
  const conversation = new ConversationThread({
    connectionId: context.connectionId,
    partnerUserId: context.partnerUserId,
    sprintId: context.sprintId,
    partnerName: context.partnerName,
  });

  if (
    [ACTION_MESSAGE_PARTNER, ACTION_OPEN_SPRINT, ACTION_START_SPRINT, ACTION_ENCOURAGE].includes(
      key
    ) &&
    !context.partnerUserId &&
    !context.connectionId &&
    !context.sprintId
  ) {
    warnings.push("partner context is missing");
  }

  let resolved;

  switch (key) {
    case ACTION_MESSAGE_PARTNER:
      if (conversation.hasActiveSprint) {
        resolved = {
          key,
          label: conversation.messageLabel,
          audience: "partner",
          destination: "sprint",
          route: conversation.getRoute({
            focus: "composer",
            source,
          }),
          warnings,
        };
        break;
      }

      resolved = {
        key,
        label: conversation.messageLabel,
        audience: "partner",
        destination: "direct_thread",
        route: conversation.getRoute({
          compose: Boolean(context.message),
          source,
          message: context.message,
        }),
        warnings,
      };
      break;

    case ACTION_SHARE_TO_NETWORK:
      resolved = {
        key,
        label: "Share with your circle",
        audience: "circle",
        destination: "network",
        route: (() => {
          const params = new URLSearchParams();
          params.set("tab", "activity");
          params.set("compose", "1");
          if (context.message) params.set("message", String(context.message));
          return `/activity?${params.toString()}`;
        })(),
        warnings,
      };
      break;

    case ACTION_CHECK_IN:
      resolved = {
        key,
        label: "Check in",
        audience: "self",
        destination: "today",
        route: "/",
        warnings,
      };
      break;

    case ACTION_COMPLETE_ACTION:
      resolved = {
        key,
        label: "Do one habit",
        audience: "self",
        destination: "today",
        route: "/",
        warnings,
      };
      break;

    case ACTION_START_SPRINT:
      resolved = {
        key,
        label: "Start Accountability",
        audience: "partner",
        destination: "connections",
        route: null,
        warnings,
      };
      break;

    case ACTION_OPEN_SPRINT:
      if (!conversation.hasActiveSprint) {
        warnings.push("open_sprint is missing sprint context");
      }
      resolved = {
        key,
        label: "Open Accountability",
        audience: "partner",
        destination: "sprint",
        route: conversation.hasActiveSprint
          ? conversation.getRoute({ source })
          : null,
        warnings,
      };
      break;

    case ACTION_ENCOURAGE:
      if (conversation.hasActiveSprint) {
        resolved = {
          key,
          label: "Encourage",
          audience: "partner",
          destination: "sprint",
          route: conversation.getRoute({ focus: "composer", source }),
          warnings,
        };
        break;
      }

      resolved = {
        key,
        label: "Encourage",
        audience: "partner",
        destination: "direct_thread",
        route: conversation.getRoute(
          {
            compose: true,
            source,
            quickAction: "encourage",
            message: context.message,
          }
        ),
        warnings,
      };
      break;

    default:
      resolved = {
        key,
        label: "",
        audience: "self",
        destination: "today",
        route: null,
        warnings: [...warnings, "unknown canonical action"],
      };
  }

  warnInDev(key, resolved.warnings);
  return resolved;
}
